const Error = () => {
    return (
        <div className="error-container">
            <div className="error">OOPS SOMETHING WENT WRONG !!!</div>
        </div>
    )
}

export default Error;